export default function useAuthTokensValidCheck() {
  const accessToken = localStorage.getItem('accessToken');
  const accessExpiry = accessToken ? parseInt(JSON.parse(atob(accessToken.split('.')[1])).exp, 10) : null;
  const refreshToken = localStorage.getItem('refreshToken');
  const refreshExpiry = refreshToken ? parseInt(JSON.parse(atob(refreshToken.split('.')[1])).exp, 10) : null;
  return (accessExpiry && (accessExpiry * 1000 - 10000 > Date.now())) || (refreshExpiry && (refreshExpiry * 1000 - 10000 > Date.now()));
}
